/* ==========================================================================
   yofuke — theme.js
   Everything here is progressive enhancement. With JavaScript switched off
   the product form still posts to /cart/add and the cart page still works.
   ========================================================================== */
(function () {
  "use strict";

  var cfg = window.theme || {};
  var money = function (cents) {
    try {
      return new Intl.NumberFormat(cfg.locale || "en", {
        style: "currency",
        currency: cfg.currency || "JPY",
        maximumFractionDigits: cfg.currency === "JPY" ? 0 : 2
      }).format(cents / (cfg.currency === "JPY" ? 1 : 100));
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };

  /* ---------------- cart drawer ---------------- */
  var drawer = document.getElementById("cart-drawer");
  var scrim = document.getElementById("scrim");
  var lines = document.getElementById("cart-lines");
  var pip = document.querySelectorAll("[data-cart-count]");
  var subtotal = document.getElementById("cart-subtotal");
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("on");
    drawer.setAttribute("aria-hidden", "false");
    scrim.classList.add("on");
    document.body.style.overflow = "hidden";
    var close = drawer.querySelector(".close");
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("on");
    drawer.setAttribute("aria-hidden", "true");
    scrim.classList.remove("on");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }

  function paint(cart) {
    for (var i = 0; i < pip.length; i++) pip[i].textContent = cart.item_count;
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML =
        '<p class="empty">' + (cfg.strings.empty || "Nothing here yet.") + "</p>";
      return;
    }
    lines.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img class="swatch" src="' + item.image.replace(/(\.[^.]*)$/, "_120x$1") + '" alt="">'
          : '<span class="swatch"></span>';
        var opts =
          item.variant_title && item.variant_title !== "Default Title"
            ? item.variant_title + " · "
            : "";
        return (
          "<li>" + img +
          "<div><strong>" + item.product_title + "</strong>" +
          "<span>" + opts + item.quantity + " × " + money(item.price) + "</span><br>" +
          '<a class="rm" href="#" data-remove="' + item.key + '">' +
          (cfg.strings.remove || "Remove") + "</a></div></li>"
        );
      })
      .join("");
  }

  function refresh() {
    return fetch(cfg.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(paint);
  }

  if (scrim) scrim.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });
  document.querySelectorAll("[data-open-cart]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      refresh().then(openDrawer);
    });
  });
  document.querySelectorAll("[data-close-cart]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });

  if (lines) {
    lines.addEventListener("click", function (e) {
      var link = e.target.closest("[data-remove]");
      if (!link) return;
      e.preventDefault();
      fetch(cfg.routes.cart_change + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: link.getAttribute("data-remove"), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(paint);
    });
  }

  /* ---------------- add to cart ---------------- */
  var form = document.getElementById("product-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn.textContent;
      btn.textContent = cfg.strings.adding || "Adding…";
      fetch(cfg.routes.cart_add + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          btn.textContent = original;
          if (!res.ok) {
            var msg = form.querySelector("[data-form-msg]");
            if (msg) {
              msg.textContent = res.d.description || res.d.message;
              msg.className = "form-msg err";
            }
            return;
          }
          return refresh().then(openDrawer);
        })
        .catch(function () {
          form.submit(); // fall back to a normal post
        });
    });
  }

  /* ---------------- variant picker ---------------- */
  var picker = document.getElementById("variant-picker");
  if (picker) {
    picker.addEventListener("change", function (e) {
      var input = e.target.closest('input[name="id"]');
      if (!input) return;
      var price = document.getElementById("p-price");
      if (price && input.dataset.price) price.innerHTML = input.dataset.price;
      var btn = document.querySelector('#product-form [type="submit"]');
      if (btn) {
        var sold = input.dataset.available === "false";
        btn.disabled = sold;
        btn.textContent = sold
          ? cfg.strings.sold_out || "Sold out"
          : cfg.strings.add || "Add to cart";
      }
    });
  }

  /* ---------------- product gallery ---------------- */
  var main = document.getElementById("p-main-image");
  var thumbs = document.getElementById("p-thumbs");
  if (main && thumbs) {
    thumbs.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      main.src = b.dataset.full;
      main.srcset = "";
      thumbs.querySelectorAll("button").forEach(function (x) {
        x.setAttribute("aria-current", String(x === b));
      });
    });
  }
})();
